import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  OutlinedInput,
  Box,
} from "@mui/material";

const MultiTagSelector = ({ config, tagsData, updateSelectFilter }) => {
  const selectedTagIds = config.tagFilter
    ? config.tagFilter.split(",").map((id) => id.trim())
    : [];

  const handleChange = (event) => {
    const value = event.target.value;
    const stringValue = value.join(",");
    updateSelectFilter("tagFilter", stringValue);
  };

  return (
    <FormControl size="small" style={{ minWidth: 200 }}>
      <InputLabel>Select Tags Filter</InputLabel>
      <Select
        multiple
        value={selectedTagIds}
        onChange={handleChange}
        input={<OutlinedInput label="Select Tags Filter" />}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((tagId) => {
              const tag = tagsData.find((t) => String(t.tagId) === tagId);
              return (
                <Chip
                  key={tagId}
                  label={tag?.tagName || tagId}
                  onMouseDown={(e) => e.stopPropagation()}
                />
              );
            })}
          </Box>
        )}
      >
        {tagsData?.map((tag) => (
          <MenuItem key={tag.tagId} value={String(tag.tagId)}>
            {tag.tagName}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiTagSelector;
